<template>
	<div class="flex flex_col environapage">
		<!-- 上面的选择 -->
		<div class="selects">
			<el-form
				:model="queryParam"
				ref="ruleform"
				:inline="true"
				class="flex flex_ju_sb warnform-inline"
			>
				<div class="form-inputs">
					<el-form-item label="选择设备">
						<el-select
							placeholder="请选择"
							v-model="queryParam.deviceCode"
							@change="deviceCodeChange"
							multiple
							:multiple-limit="3"
							collapse-tags
							:class="{ 'selest-more': queryParam.deviceCode.length > 1 }"
						>
							<el-option
								v-for="(item, index) in orgSelect"
								:key="index"
								:value="item.facId"
								:label="item.facName"
							></el-option>
						</el-select>
					</el-form-item>

					<!-- 中间参数选择 -->
					<!-- 单设备多参数 -->
					<!-- <div style="display: inline-block"> -->
					<el-form-item v-show="isOneOption">
						<el-radio-group
							v-model="radioIndex"
							class="form-radio-group"
							@change="radioIndexChange"
						>
							<el-radio :disabled="isDisabledChooseRadio" :label="1"
								>温度、土壤温度</el-radio
							>
							<el-radio :disabled="isDisabledChooseRadio" :label="2"
								>湿度、土壤湿度</el-radio
							>
							<el-radio :label="3">选择参数</el-radio>
						</el-radio-group>
						<el-select
							placeholder="请选择"
							v-model="singleSbItemAct"
							:disabled="isItemDisabled"
							multiple
							:multiple-limit="3"
							collapse-tags
							@change="singleSbItemActChange"
						>
							<el-option
								:label="item.itemName"
								:value="item.itemCode"
								v-for="(item, index) in singleSbItemLIst"
								:key="index"
							></el-option>
						</el-select>
					</el-form-item>
					<!-- </div> -->
					<!-- 多设备单参数 -->
					<el-form-item v-show="!isOneOption" label="参数选择">
						<el-select
							placeholder="请选择"
							v-model="moreSbItemAct"
							@change="moreSbItemActChange"
						>
							<el-option
								:label="item.itemName"
								:value="item.itemCode"
								v-for="(item, index) in moreSbItemList"
								:key="index"
							></el-option>
						</el-select>
					</el-form-item>

					<el-form-item label="时间区间" class="form-picker">
						<div class="picker-divs">
							<el-date-picker
								v-model="queryParam.startTime"
								size="small"
								type="date"
								format="yyyy-MM-dd"
								value-format="yyyy-MM-dd"
								placeholder="选择日期"
								popper-class="pick-poper"
								class="picker-div"
								prefix-icon=" "
								clear-icon="el-icon-date"
								:clearable="false"
								:picker-options="pickerOptions0"
								:editable="false"
							>
							</el-date-picker>
							<i class="pick-icon el-icon-date"></i>
						</div>

						<span class="pick-word">至</span>
						<div class="picker-divs">
							<el-date-picker
								v-model="queryParam.endTime"
								size="small"
								type="date"
								format="yyyy-MM-dd"
								value-format="yyyy-MM-dd"
								placeholder="选择日期"
								popper-class="pick-poper"
								class="picker-div"
								prefix-icon=" "
								clear-icon="el-icon-date"
								:clearable="false"
								:picker-options="pickerOptions1"
								:editable="false"
							>
							</el-date-picker>
							<i class="pick-icon el-icon-date"></i>
						</div>
					</el-form-item>
				</div>
				<el-form-item class="form-btns">
					<el-button type="primary" @click="onSubmit">查询</el-button>
					<el-button type="primary" @click="exportDownLoad">导出</el-button>
				</el-form-item>
			</el-form>
		</div>
		<!-- 下面的折线图 -->
		<div class="chart-all" v-loading="loading">
			<!-- 导出按钮 -->
			<!-- <div class="flex flex_a_c flex_ju_c btn-export" @click="exportDownLoad">
				<img src="../../assets/image/analysis/icon_export.png" alt="" />导出
			</div> -->
			<!-- 图表 -->
			<div class="chart-div" ref="chartRef" v-show="isShowLine"></div>
			<div
				class="table-empty flex flex_col flex_ju_c flex_a_c bottom-empty"
				v-show="!isShowLine"
			>
				<img class="table-noimg" src="@/assets/image/home/img_none.png" alt="" />
				<div class="table-emptyword">暂无数据</div>
			</div>
			<!-- 底部说明文字 -->
			<!--			<div class="font_16 chart-title">多设备单参数对比图</div>-->
		</div>
	</div>
</template>

<script>
/**
 * @description 环境参数分析
 * 上面的表单选择：设备单个，后面可自由选择；设备多个，后面单个选择
 */
import qs from 'qs'
import tableMinin from '@/mixins/TableMinin'
import {
	prevDayTime,
	GetPreMonthDay,
	GetNextMonthDay,
	getFormatDate,
} from '../../times/moment'
export default {
	mixins: [tableMinin],
	data() {
		const self = this
		return {
			isShowLine: false, // 是否显示折线图
			orgSelect: [],
			radioIndex: 1,
			singleSbItemLIst: [], //单设备采集项
			singleSbItemAct: [],
			moreSbItemList: [], //多设备采集项
			moreSbItemAct: '',
			queryParam: {
				deviceCode: [],
				type: 1,
				list: ['WD', 'TRWD'],
				orgId: '',
				startTime: '',
				endTime: '',
			},
			queryArrParam: [
				// {
				//   deviceCode: "1",
				//   type: 1,
				//   list: ["WD"],
				//   orgId: "",
				//   startTime: "2022-04-10 00:00:00",
				//   endTime: "2022-04-14 23:59:59",
				// },
				// {
				//   deviceCode: "2",
				//   type: 1,
				//   list: ["WD"],
				//   orgId: "",
				//   startTime: "2022-04-10 00:00:00",
				//   endTime: "2022-04-14 23:59:59",
				// },
			],
			url: {
				oneLineChart: '/napi/index/envParamsOTMChart', // 单设备多参数
				moreLineChart: '/napi/index/envParamsMTOChart', // 多设备单参数
			},
			dataUnits: [], // 数据的单位数据，用作折线图tooltip上面单位的赋值
			pickerOptions0: {
				disabledDate: (time) => {
					if (this.queryParam.endTime) {
						if (this.queryParam.endTime != '') {
							let num = new Date(this.queryParam.endTime).getTime()
							return time.getTime() > num
						} else {
						}
					} else {
						return false
					}
				},
			},
			pickerOptions1: {
				disabledDate: (time) => {
					let num = new Date().getTime()
					if (time.getTime() > num) {
						return true
					} else {
						let startNum =
							new Date(this.queryParam.startTime).getTime() - 43200000
						if (time.getTime() < startNum) {
							return true
						} else {
							return false
						}
					}
				},
			},
			moreAllData: [],
		}
	},
	computed: {
		// 是否是单设备多参数
		isOneOption() {
			// if (this.queryParam.deviceCode.length == 1) {
			// 	// 唯一选中的一个设备
			// 	let firsts = this.queryParam.deviceCode[0]
			// 	// 查找选中的对象
			// 	let findIndex = this.orgSelect.findIndex((item) => {
			// 		return item.facId == firsts
			// 	})
			// 	// 判断是否是气象设备
			// 	if (findIndex > -1 && this.orgSelect[findIndex]['type'] == 3) {
			// 		return true
			// 	}
			// }
			if (this.queryParam.deviceCode.length > 1) {
				return false
			}
			return true
			// return false
		},
		// 单设备时参数选择是否可以选中
		isItemDisabled() {
			if (this.radioIndex == '3') {
				return false
			}
			return true
		},
		// 是否可以选择固定的温度和湿度
		isDisabledChooseRadio() {
			if (this.queryParam.deviceCode.length == 1) {
				// 唯一选中的一个设备
				let firsts = this.queryParam.deviceCode[0]
				// 查找选中的对象
				let findIndex = this.orgSelect.findIndex((item) => {
					return item.facId == firsts
				})
				// 判断是否是气象设备
				if (findIndex > -1 && this.orgSelect[findIndex]['type'] == 3) {
					return false
				}
			}
			return true
		},
	},
	created() {},
	mounted() {
		this.$set(this.queryParam, 'startTime', this.getNowDate())
		this.$set(this.queryParam, 'endTime', this.getNowDate())
		this.getOrgids()
		// this.makeChart()
		// 单设备多参数
		// this.getOneLineData()
		// 多设备单参数
		// this.getMoreLineData()
	},

	methods: {
		getOrgids() {
			let userInfo = this.getItem('wlwUserInfo') || {}
			let userInfos = JSON.parse(userInfo)
			this.$set(this.queryParam, 'orgId', userInfos.orgId)
			// this.$set(this.queryArrParam[0], "orgId", userInfos.orgId);
			let params = {
				// parentOrgId: userInfos.orgId,
				orgId: userInfos.orgId,
			}
			this.$http
				.getAction(this.$api.findFarmingByOrgCode, params)
				.then((res) => {
					console.log(res)
					if (res.meta.success) {
						let datas = res.data || []
						if (datas && datas.length) {
							//添加商请设备
							// this.getSQSBBYDap(userInfos.orgId)
							// datas.forEach((item, index) => {
							// 	if (index == datas.length - 1) {
							// 		// 获取传感器设备
							// 		this.getCGQSBByDap(item.id, true)
							// 	} else {
							// 		this.getCGQSBByDap(item.id, false)
							// 	}
							// })
							// 添加气象设备
							this.getQXSBBYdap(userInfos.orgId)
							// 获取页面上相关的其它数据
							setTimeout(() => {
								// 获取折线图数据
								this.getOneLineData()
							}, 500)
						} else {
							setTimeout(() => {
								this.loading = false
							}, 200)
						}
					} else {
						// this.orgSelect = [];
						setTimeout(() => {
							this.loading = false
						}, 200)
					}
				})
				.catch(() => {
					// this.orgSelect = [];
					setTimeout(() => {
						this.loading = false
					}, 200)
				})
		},
		// 根据大棚获取气象站设备列表
		getQXSBBYdap(id) {
			let params = {
				orgId: id,
			}
			// this.$http.getAction(this.$api.qxSelectNew, params).then((res) => {
			// 	// console.log(res);
			// 	if (res.meta.success) {
			// 		let datas = res.data || []
			// 		if (datas && datas.length) {
			// 			datas.forEach((item) => {
			// 				let obj = {
			// 					facId: item.facId,
			// 					facName: item.facName,
			// 					type: 3,
			// 					orgId: id,
			// 				}
			// 				const a = JSON.parse(JSON.stringify(obj))
			// 				this.orgSelect.unshift(a)
			// 			})
			// 			this.$set(this.queryParam.deviceCode, 0, this.orgSelect[0].facId)
			// 		}
			// 	}
			// })

			this.$http.getAction(this.$api.analysisNew, params).then((res) => {
				// console.log(res);
				if (res.meta.success) {
					let datas = res.data || []
					this.orgSelect = datas || []
					if (datas && datas.length) {
						for (const i in this.orgSelect) {
							let deviceTypeCategory =
								this.orgSelect[i]['deviceTypeCategory']
							let types = ''
							if (deviceTypeCategory == '1') {
								types = '3'
							} else if (deviceTypeCategory == '3') {
								types = '1'
							} else {
								types = deviceTypeCategory
							}
							this.orgSelect[i]['facId'] = this.orgSelect[i]['id']
							this.orgSelect[i]['facName'] = this.orgSelect[i]['deviceName']
							this.orgSelect[i]['type'] = types
							this.orgSelect[i]['orgId'] = this.orgSelect[i]['orgId']
							this.orgSelect[i]['typeId'] = this.orgSelect[i]['typeId']
						}
						this.$set(this.queryParam.deviceCode, 0, this.orgSelect[0].facId)
					}
				}
			})
		},
		// 根据大棚获取商请设备列表
		getSQSBBYDap(id) {
			let params = {
				orgId: id,
			}
			this.$http.getAction(this.$api.sqSelectNew, params).then((res) => {
				// console.log(res);
				if (res.meta.success) {
					let datas = res.data || []
					if (datas && datas.length) {
						datas.forEach((item) => {
							let obj = {
								facId: item.facId,
								facName: item.facName,
								type: 2,
								orgId: id,
							}
							const a = JSON.parse(JSON.stringify(obj))
							this.orgSelect.push(a)
						})
						// this.$set(this.queryParam.deviceCode, 0, this.orgSelect[0].facId)
					}
				}
			})
		},
		// 根据大棚获取传感器设备列表
		getCGQSBByDap(id, isEnd) {
			let params = {
				orgId: id,
			}
			this.$http.getAction(this.$api.findDeviceByOrgId, params).then((res) => {
				// console.log(res);
				if (res.meta.success) {
					let datas = res.data || []
					if (datas && datas.length) {
						datas.forEach((item) => {
							let obj = {
								facId: item.serialNumber + '-' + id,
								facName: item.deviceName,
								type: 1,
								orgId: id,
								typeId: item.typeId,
							}
							const a = JSON.parse(JSON.stringify(obj))
							this.orgSelect.push(a)
						})
						if (isEnd) {
							this.$set(
								this.queryParam.deviceCode,
								0,
								this.orgSelect[0].facId
							)
						}

						// this.orgSelect = this.removal2(this.orgSelect);
					}
				}
			})
		},
		// 设备切换
		deviceCodeChange(val) {
			console.log(this.isOneOption)
			// 清空所有采集项下拉选
			this.singleSbItemLIst = []
			this.moreSbItemList = []
			this.singleSbItemAct = []
			this.moreSbItemAct = ''
			// 选择单设备
			if (this.queryParam.deviceCode.length == 1) {
				// 如果选中的是自定义参数
				if (this.radioIndex == 3) {
					// 获取采集项
					let sbItem = {}
					this.orgSelect.forEach((item) => {
						if (item.facId == val[0]) {
							sbItem = item
						}
					})
					this.getDeviceItems(sbItem)
				} else {
					// 否则判断是否是气象，不是气象的话，只能选择后面的
					// 唯一选中的一个设备
					let firsts = val[0]
					// 查找选中的对象
					let findIndex = this.orgSelect.findIndex((item) => {
						return item.facId == firsts
					})
					// 判断是否是气象设备
					if (findIndex > -1 && this.orgSelect[findIndex]['type'] == 3) {
						this.radioIndex = 1
						this.singleSbItemAct = []
						this.singleSbItemLIst = []
						let arr = ['WD', 'TRWD']
						this.queryParam.list = arr
					} else {
						this.radioIndex = 3
						let sbItem = {}
						this.orgSelect.forEach((item) => {
							if (item.facId == val[0]) {
								sbItem = item
							}
						})
						this.getDeviceItems(sbItem)
					}
				}
			}
			if (this.queryParam.deviceCode.length > 1) {
				// 选择多设备
				let sbArr = []
				this.orgSelect.forEach((item) => {
					this.queryParam.deviceCode.forEach((item2) => {
						if (item.facId == item2) {
							sbArr.push(item)
						}
					})
				})
				this.getmoreSbItemList(sbArr)
			}
			this.$forceUpdate()
		},
		// 单选框切换
		radioIndexChange() {
			this.singleSbItemLIst = []
			this.moreSbItemList = []
			this.singleSbItemAct = []
			this.moreSbItemAct = ''
			if (this.radioIndex == 3) {
				// 获取采集项
				let sbArr = {}
				this.orgSelect.forEach((item) => {
					if (item.facId == this.queryParam.deviceCode) {
						sbArr = item
					}
				})
				this.getDeviceItems(sbArr)
			}
			if (this.radioIndex == 1) {
				this.singleSbItemAct = []
				this.singleSbItemLIst = []
				let arr = ['WD', 'TRWD']
				this.queryParam.list = arr
			}
			if (this.radioIndex == 2) {
				this.singleSbItemAct = []
				this.singleSbItemLIst = []
				let arr = ['SD', 'TRSD']
				this.queryParam.list = arr
			}
		},
		// 获取单设备采集项数组
		getDeviceItems(item) {
			let id = item.facId
			// 气象设备采集项
			if (item.type == 3) {
				let params = {
					facId: id,
				}
				this.$http.getAction(this.$api.qxgetDeviceItems, params).then((res) => {
					if (res.meta.success) {
						let datas = res.data || []
						if (datas && datas.length) {
							this.singleSbItemLIst = datas
							this.singleSbItemAct = []
							// this.singleSbItemAct.push(this.singleSbItemLIst[0].itemCode)
							// let arr = [];
							// arr.push(this.singleSbItemAct);
							// this.queryParam.list = arr;
							this.queryParam.list = this.singleSbItemAct
						} else {
							this.singleSbItemAct = []
							this.singleSbItemLIst = []
							this.queryParam.list = this.singleSbItemAct
						}
					} else {
						this.singleSbItemAct = []
						this.singleSbItemLIst = []
						this.queryParam.list = this.singleSbItemAct
					}
				})
			}
			if (item.type == 2) {
				let params = {
					facId: id,
				}
				this.$http.getAction(this.$api.soilgetDeviceItems, params).then((res) => {
					console.log(res)
					if (res.meta.success) {
						let datas = res.data || []
						if (datas && datas.length) {
							this.singleSbItemLIst = datas
							// this.singleSbItemAct = this.singleSbItemLIst[0].itemCode;
							// let arr = [];
							// arr.push(this.singleSbItemAct);
							// this.queryParam.list = arr;
							// this.singleSbItemAct.push(this.singleSbItemLIst[0].itemCode)

							this.singleSbItemAct = []
							this.queryParam.list = this.singleSbItemAct
						} else {
							this.singleSbItemAct = []
							this.singleSbItemLIst = []
							this.queryParam.list = []
						}
					} else {
						this.singleSbItemAct = []
						this.singleSbItemLIst = []
						this.queryParam.list = this.singleSbItemAct
					}
				})
			}
			if (item.type == 1) {
				let params = {
					deviceTypeId: item.typeId,
				}
				this.$http.getAction(this.$api.getDeviceItems, params).then((res) => {
					// console.log(res);
					if (res.meta.success) {
						let datas = res.data || []
						if (datas && datas.length) {
							let newDatas = []
							datas.forEach((item) => {
								newDatas.push({
									itemName: item.name,
									itemCode: item.code,
								})
							})
							this.singleSbItemLIst = newDatas
							// this.singleSbItemAct = this.singleSbItemLIst[0].itemCode;
							// let arr = [];
							// arr.push(this.singleSbItemAct);
							// this.queryParam.list = arr;
							// this.singleSbItemAct.push(this.singleSbItemLIst[0].itemCode)
							this.singleSbItemAct = []
							this.queryParam.list = this.singleSbItemAct
						} else {
							this.singleSbItemLIst = []
							this.singleSbItemAct = []
							this.queryParam.list = this.singleSbItemAct
						}
					} else {
						this.singleSbItemAct = []
						this.singleSbItemLIst = []
						this.queryParam.list = this.singleSbItemAct
					}
				})
			}
			this.$forceUpdate()
		},
		// 单设备采集项切换
		singleSbItemActChange() {
			// let arr = [];
			// arr.push(this.singleSbItemAct);
			// console.log(arr);
			// this.queryParam.list = arr;
			// this.$set(this.queryParam, list, this.singleSbItemAct);
			this.queryParam.list = this.singleSbItemAct
		},
		// 获取多设备采集项数组
		getmoreSbItemList(arr) {
			let itemlistArr = []
			arr.forEach((item) => {
				let id = item.facId
				// 气象设备采集项
				if (item.type == 3) {
					let params = {
						facId: id,
					}
					this.$http
						.getAction(this.$api.qxgetDeviceItems, params)
						.then((res) => {
							if (res.meta.success) {
								let datas = res.data || []
								if (datas && datas.length) {
									datas.forEach((item2) => {
										itemlistArr.push(item2)
									})
								} else {
								}
							}
						})
				}
				if (item.type == 2) {
					let params = {
						facId: id,
					}
					this.$http
						.getAction(this.$api.soilgetDeviceItems, params)
						.then((res) => {
							if (res.meta.success) {
								let datas = res.data || []
								if (datas && datas.length) {
									datas.forEach((item2) => {
										console.log(item2)
										itemlistArr.push(item2)
									})
								} else {
								}
							}
						})
				}
				if (item.type == 1) {
					let params = {
						deviceTypeId: item.typeId,
					}
					this.$http.getAction(this.$api.getDeviceItems, params).then((res) => {
						if (res.meta.success) {
							let datas = res.data || []
							if (datas && datas.length) {
								datas.forEach((item2) => {
									itemlistArr.push({
										itemName: item2.name,
										itemCode: item2.code,
									})
								})
							} else {
							}
						}
					})
				}
			})
			setTimeout(() => {
				// 采集项去重，已选数据清空
				this.moreSbItemList = this.removal(itemlistArr)
				this.moreSbItemAct = this.$options.data().moreSbItemAct
			}, 800)
		},
		// 多设备采集项切换
		moreSbItemActChange() {
			console.log(this.moreSbItemAct)
		},
		// 去重
		removal(tempArr) {
			let result = []
			let obj = {}
			for (let i = 0; i < tempArr.length; i++) {
				if (!obj[tempArr[i].itemCode]) {
					result.push(tempArr[i])
					obj[tempArr[i].itemCode] = true
				}
			}
			return result
		},
		// 去重2
		removal2(tempArr) {
			let result = []
			let obj = {}
			for (let i = 0; i < tempArr.length; i++) {
				if (!obj[tempArr[i].facId]) {
					result.push(tempArr[i])
					obj[tempArr[i].facId] = true
				}
			}
			return result
		},
		// 查询按钮点击
		onSubmit() {
			this.$refs['ruleform'].validate((valid) => {
				console.log(valid)
				if (valid) {
					if (!this.queryParam.deviceCode.length) {
						this.loading = false
						return false
					}

					let miao = this.queryParam.startTime.split(' ')[1] || '00:00:00'
					let preMonthDay = new Date(
						GetNextMonthDay(getFormatDate(this.queryParam.startTime), 6) +
							' ' +
							miao
					) //6个月之后的日期
					let startTimeCuo = new Date(this.queryParam.endTime).getTime()
					if (startTimeCuo >= preMonthDay.getTime()) {
						this.$message('选择时间跨度范围不允许超过6个月', 'warning')
						this.loading = false
						return false
					}
					// 单设备多参数
					if (this.isOneOption) {
						if (this.radioIndex != 3) {
							this.loading = true
							this.getOneLineData()
						} else {
							if (this.singleSbItemAct.length) {
								this.loading = true
								this.getOneLineData()
							} else {
								this.$message('请至少选中一项参数', 'warning')
							}
						}
					} else {
						if (this.moreSbItemAct) {
							//多设备单参数
							let sbid = this.queryParam.deviceCode //选择设备id
							let caijiItem = this.moreSbItemAct.split(' ') //选中采集项
							let startTime_ = this.queryParam.startTime //时间
							let endTime_ = this.queryParam.endTime //时间
							let nowArr = []
							console.log(this.orgSelect)
							sbid.forEach((item) => {
								let type_
								let orgId_ = ''
								let deviceCode_
								this.orgSelect.forEach((item2) => {
									if (item2.facId == item) {
										type_ = item2.type

										if (type_ == 1) {
											orgId_ = item2.orgId
											deviceCode_ = item2.serialNumber
										} else {
											deviceCode_ = item
										}
									}
								})
								let userOrg = this.getItem('wlwOrg') || {}
								let userOrgs = JSON.parse(userOrg)
								nowArr.push({
									deviceCode: deviceCode_,
									type: type_,
									list: caijiItem,
									orgId: orgId_,
									startTime: `${startTime_} 00:00:00`,
									endTime: `${endTime_} 23:59:59`,
									orgType: userOrgs.orgType,
								})
							})
							this.queryArrParam = nowArr
							this.loading = true
							this.getMoreLineData()
						} else {
							this.$message('请至少选中一项参数', 'warning')
						}
					}
				} else {
					console.log('error submit!!')
					this.loading = false
					return false
				}
			})
		},
		// 请求折线图数据 ---- 单设备多参数
		getOneLineData() {
			const _this = this
			this.loading = true
			console.log(this.orgSelect)
			console.log(this.queryParam)
			let params = JSON.parse(JSON.stringify(this.queryParam))
			params.startTime = `${params.startTime} 00:00:00`
			params.endTime = `${params.endTime} 23:59:59`
			this.orgSelect.forEach((item) => {
				if (item.facId == params.deviceCode) {
					this.$set(params, 'type', item.type)
				}
			})
			if (params.type != 1) {
				this.$set(params, 'orgId', '')
			} else {
				let orgId_ = ''
				let deviceCode_ = []
				this.orgSelect.forEach((item) => {
					if (item.facId == params.deviceCode) {
						orgId_ = item.orgId
						deviceCode_.push(item.serialNumber)
						this.$set(params, 'orgId', item.orgId)
						this.$set(params, 'deviceCode', deviceCode_)
					}
				})
				console.log(1)
			}
			if (params.deviceCode.length) {
				this.$set(params, 'deviceCode', params.deviceCode[0])
			} else {
				this.$set(params, 'deviceCode', this.orgSelect[0]['facId'])
				this.$set(this.queryParam.deviceCode, 0, this.orgSelect[0].facId)
			}
			console.log(params)
			this.$http
				.postAction(this.url.oneLineChart, params)
				.then((res) => {
					if (res.meta.success) {
						let datas = res.data
						// console.log(datas);
						if (datas && datas != {}) {
							this.isShowLine = true
							let result
							let xData = []
							let lenData = [] //类型数组
							let series = []
							let yAxis = []
							let dataTypeNum = Object.keys(datas)
							console.log(dataTypeNum)
							// 传感器设备返回数据处理
							if (dataTypeNum == 1) {
								result = datas[1]

								// 判断是否选中的是前两个
								if (_this.radioIndex == 1 || _this.radioIndex == 2) {
									let times = []
									Object.keys(result).forEach((keys, indexx) => {
										if (indexx == 0) {
											yAxis = {
												type: 'value',
												name: result[keys].unit,
												nameTextStyle: {
													color: '#6B6B6B',
													fontSize: 14,
													align: 'right',
												},
												axisLabel: {
													color: '#6B6B6B',
													fontSize: 14,
												},
												axisLine: {
													show: true,
													lineStyle: {
														color: '#EDEDED',
														width: 2,
													},
												},
												splitLine: {
													show: true,
													lineStyle: {
														color: 'rgba(9, 116, 124, .3)',
													},
												},
											}
											times = result[keys]['acquisitionTimes']
											xData = times
										}

										let oneAllData = []
										times.forEach((timeItem, timeIndex) => {
											let oneData = []
											oneData[0] = timeItem
											oneData[1] = result[keys]['values'][timeIndex]
											oneAllData.push(oneData)
										})
										series.push({
											type: 'line',
											// yAxisIndex: 0,
											smooth: true,
											showSymbol: false,
											symbolSize: 10,
											itemStyle: {
												borderWidth: 8,
											},
											lineStyle: {
												width: 4,
											},
											name: result[keys]['acquisitionItemName'],
											data: oneAllData,
										})
										lenData.push(keys)
									})
								} else {
									Object.keys(result).forEach((keys, indexx) => {
										this.$set(
											this.dataUnits,
											result[keys]['acquisitionItemName'],
											result[keys]['unit']
										)
										if (indexx == 0) {
											// x轴数据赋值
											xData = result[keys]['acquisitionTimes']
										}
										let lenIndex = lenData.findIndex((kk) => {
											return kk == keys
										})
										if (lenIndex > -1) {
										} else {
											let aa = {
												type: 'value',
												name: result[keys].unit,
												nameTextStyle: {
													color: '#6B6B6B',
													fontSize: 14,
													align: 'right',
												},
												axisLabel: {
													color: '#6B6B6B',
													fontSize: 14,
												},
												axisLine: {
													show: true,
													lineStyle: {
														color: '#EDEDED',
														width: 2,
													},
												},
												splitLine: {
													show: true,
													lineStyle: {
														color: 'rgba(9, 116, 124, .3)',
													},
												},
											}
											if (indexx != 0) {
												aa.position = 'left'
												aa.offset = indexx * 55
												aa.splitLine.show = false
											}
											yAxis.push(aa)
											series.push({
												type: 'line',
												yAxisIndex: indexx,
												// yAxisIndex: 0,
												smooth: true,
												showSymbol: false,
												symbolSize: 10,
												itemStyle: {
													borderWidth: 8,
												},
												lineStyle: {
													width: 4,
												},
												name: result[keys]['acquisitionItemName'],
												data: result[keys]['values'],
											})
											lenData.push(keys)
										}
									})
								}
							}
							// 商请数据返回处理
							if (dataTypeNum == 2) {
								result = datas[2]
								// Object.keys(result).forEach((key, indexx) => {
								//   xData.push(key);
								//   if (indexx == Object.keys(result).length - 1) {
								//     result[key].forEach((item, index) => {
								//       this.$set(
								//         this.dataUnits,
								//         item["acquisitionItemName"],
								//         item["acquisitionItemUnitCode"]
								//       );
								//       // console.log(this.dataUnits);
								//       // let aa = {
								//       //   type: "value",
								//       //   name: item.acquisitionItemUnitCode,
								//       //   nameTextStyle: {
								//       //     color: "#6B6B6B",
								//       //     fontSize: 12,
								//       //     align: "right",
								//       //   },
								//       //   axisLabel: {
								//       //     color: "#6B6B6B",
								//       //     fontSize: 14,
								//       //   },
								//       //   axisLine: {
								//       //     show: true,
								//       //     lineStyle: {
								//       //       color: "#EDEDED",
								//       //       width: 2,
								//       //     },
								//       //   },
								//       //   splitLine: {
								//       //     show: true,
								//       //     lineStyle: {
								//       //       color: "rgba(9, 116, 124, .3)",
								//       //     },
								//       //   },
								//       // };
								//       // if (index != 0) {
								//       //   aa.position = "left";
								//       //   aa.offset = index * 55;
								//       //   aa.splitLine.show = false;
								//       // }
								//       // yAxis.push(aa);
								//     });
								//   }
								// });
								// // data数据
								// let dataIndObj1 = {};
								// dataIndObj1.data = [];
								// let dataIndObj2 = {};
								// dataIndObj2.data = [];
								// let dataIndObj3 = {};
								// dataIndObj3.data = [];
								// let dataLength = 0;
								// Object.keys(result).forEach((item2, index2) => {
								//   if (index2 == 0) {
								//     dataLength = result[item2].length;
								//   }
								//   result[item2].forEach((item2_1, index2_2) => {
								//     let sData;
								//     if (index2_2 == 0) {
								//       dataIndObj1.data.push(item2_1.acquisitionData);
								//       dataIndObj1.name = item2_1.acquisitionItemName;
								//       dataIndObj1.smooth = true;
								//       dataIndObj1.showSymbol = false;
								//       dataIndObj1.symbolSize = 10;
								//       dataIndObj1.type = "line";
								//       dataIndObj1.unit = item2_1.acquisitionItemUnitCode;
								//       dataIndObj1.yAxisIndex = 0;
								//     }
								//     if (index2_2 == 1) {
								//       dataIndObj2.data.push(item2_1.acquisitionData);
								//       dataIndObj2.name = item2_1.acquisitionItemName;
								//       dataIndObj2.smooth = true;
								//       dataIndObj2.showSymbol = false;
								//       dataIndObj2.symbolSize = 10;
								//       dataIndObj2.type = "line";
								//       dataIndObj2.unit = item2_1.acquisitionItemUnitCode;
								//       dataIndObj2.yAxisIndex = 1;
								//     }
								//     if (index2_2 == 2) {
								//       dataIndObj3.data.push(item2_1.acquisitionData);
								//       dataIndObj3.name = item2_1.acquisitionItemName;
								//       dataIndObj3.smooth = true;
								//       dataIndObj3.showSymbol = false;
								//       dataIndObj3.symbolSize = 10;
								//       dataIndObj3.type = "line";
								//       dataIndObj3.unit = item2_1.acquisitionItemUnitCode;
								//       dataIndObj3.yAxisIndex = 2;
								//     }
								//   });
								// });
								// if (dataLength == 1) {
								//   series.push(dataIndObj1);
								// }
								// if (dataLength == 2) {
								//   series.push(dataIndObj1, dataIndObj2);
								// }
								// if (dataLength == 3) {
								//   series.push(dataIndObj1, dataIndObj2, dataIndObj3);
								// }
								let resData = datas[2]
								let lenData = [] //类型数组
								yAxis = []
								var data2 = []
								xData = []
								series = []
								// x轴数据
								xData = Object.keys(resData)
								if (!xData.length) {
									this.isShowLine = false
									return
								}
								Object.keys(resData).forEach((key, indexx) => {
									resData[key].forEach((item, index_) => {
										let lenIndex = lenData.findIndex((kk) => {
											return kk == item.acquisitionItemName
										})
										if (lenIndex > -1) {
										} else {
											let codeUnits = ''
											if (
												item.acquisitionItemUnitCode &&
												item.acquisitionItemUnitCode != ' ' &&
												item.acquisitionItemUnitCode != ''
											) {
												codeUnits =
													'(' +
													item.acquisitionItemUnitCode +
													')'
											} else {
												codeUnits = ''
											}
											this.$set(
												this.dataUnits,
												item['acquisitionItemName'],
												item['acquisitionItemUnitCode']
											)
											let aa = {
												show: true,
												name: codeUnits,
												type: 'value',
												nameTextStyle: {
													color: '#999',
													fontSize: 14,
													// align: 'center'
													padding: [0, 30, 0, 0],
												},
												position: 'left',
												axisLine: {
													show: true,
													lineStyle: {
														color: '#EDEDED',
														width: 2,
													},
												},
												minInterval: 1, //默认以1位分割单位，不允许出现小数点的情况
												axisLabel: {
													fontSize: 14,
													color: '#999',
												},
												splitLine: {
													show: true,
													lineStyle: {
														color: '#e9e9e9',
													},
												},
												offset: index_ * 50,
											}
											yAxis.push(aa)
											series.push({
												animationDelay: 200,
												animationDuration: 3000,
												name: item.acquisitionItemName,
												smooth: true,
												showSymbol: false,
												symbolSize: 14,
												type: 'line',
												data: [],
												unit: item.acquisitionItemUnitCode,
												yAxisIndex: index_,
											})
											lenData.push(item.acquisitionItemName)
										}
									})
								})
								// yAxis.forEach((item, index) => {
								//   item.offset = index * 50;
								// });
								// series.forEach((item, index) => {
								//   item.yAxisIndex = index;
								// });

								xData.sort(function (a, b) {
									return b < a ? 1 : -1
								})

								xData.forEach((xitem, xindex) => {
									lenData.forEach((litem, lindex) => {
										series[lindex]['data'][xindex] = 0
										resData[xitem].forEach((ditem, dindex) => {
											if (ditem.acquisitionItemName == litem) {
												series[lindex]['data'][xindex] =
													ditem.acquisitionData
											}
										})
									})
								})
							}
							// 气象数据返回处理
							if (dataTypeNum == 3) {
								// result = datas[3];
								// Object.keys(result).forEach((key, indexx) => {
								//   // xData.push(key);
								//   if (indexx == Object.keys(result).length - 1) {
								//     result[key].forEach((item, index) => {
								//       this.$set(
								//         this.dataUnits,
								//         item["acquisitionItemName"],
								//         item["acquisitionItemUnitCode"]
								//       );
								//       // console.log(this.dataUnits);
								//       // let aa = {
								//       //   type: "value",
								//       //   name: item.acquisitionItemUnitCode,
								//       //   nameTextStyle: {
								//       //     color: "#6B6B6B",
								//       //     fontSize: 14,
								//       //     align: "right",
								//       //   },
								//       //   axisLabel: {
								//       //     color: "#6B6B6B",
								//       //     fontSize: 14,
								//       //   },
								//       //   axisLine: {
								//       //     show: true,
								//       //     lineStyle: {
								//       //       color: "#EDEDED",
								//       //       width: 2,
								//       //     },
								//       //   },
								//       //   splitLine: {
								//       //     show: true,
								//       //     lineStyle: {
								//       //       color: "rgba(9, 116, 124, .3)",
								//       //     },
								//       //   },
								//       // };
								//       // if (index != 0) {
								//       //   aa.position = "left";
								//       //   aa.offset = index * 55;
								//       //   aa.splitLine.show = false;
								//       // }
								//       // yAxis.push(aa);
								//     });
								//   }
								// });
								// // data数据
								// let dataIndObj1 = {};
								// dataIndObj1.data = [];
								// let dataIndObj2 = {};
								// dataIndObj2.data = [];
								// let dataIndObj3 = {};
								// dataIndObj3.data = [];
								// let dataLength = 0;
								// Object.keys(result).forEach((item2, index2) => {
								//   if (index2 == 0) {
								//     dataLength = result[item2].length;
								//   }
								//   result[item2].forEach((item2_1, index2_2) => {
								//     let sData;
								//     if (index2_2 == 0) {
								//       dataIndObj1.data.push(item2_1.acquisitionData);
								//       dataIndObj1.name = item2_1.acquisitionItemName;
								//       dataIndObj1.smooth = true;
								//       dataIndObj1.showSymbol = false;
								//       dataIndObj1.symbolSize = 10;
								//       dataIndObj1.type = "line";
								//       dataIndObj1.unit = item2_1.acquisitionItemUnitCode;
								//       dataIndObj1.yAxisIndex = 0;
								//     }
								//     if (index2_2 == 1) {
								//       dataIndObj2.data.push(item2_1.acquisitionData);
								//       dataIndObj2.name = item2_1.acquisitionItemName;
								//       dataIndObj2.smooth = true;
								//       dataIndObj2.showSymbol = false;
								//       dataIndObj2.symbolSize = 10;
								//       dataIndObj2.type = "line";
								//       dataIndObj2.unit = item2_1.acquisitionItemUnitCode;
								//       dataIndObj2.yAxisIndex = 1;
								//     }
								//     if (index2_2 == 2) {
								//       dataIndObj3.data.push(item2_1.acquisitionData);
								//       dataIndObj3.name = item2_1.acquisitionItemName;
								//       dataIndObj3.smooth = true;
								//       dataIndObj3.showSymbol = false;
								//       dataIndObj3.symbolSize = 10;
								//       dataIndObj3.type = "line";
								//       dataIndObj3.unit = item2_1.acquisitionItemUnitCode;
								//       dataIndObj3.yAxisIndex = 2;
								//     }
								//   });
								// });
								// if (dataLength == 1) {
								//   series.push(dataIndObj1);
								// }
								// if (dataLength == 2) {
								//   series.push(dataIndObj1, dataIndObj2);
								// }
								// if (dataLength == 3) {
								//   series.push(dataIndObj1, dataIndObj2, dataIndObj3);
								// }
								let resData = datas[3]
								let lenData = [] //类型数组
								yAxis = []
								// var data2 = [];
								xData = []
								series = []
								// x轴数据
								xData = Object.keys(resData)
								if (!xData.length) {
									this.isShowLine = false
									return
								}
								Object.keys(resData).forEach((key, indexx) => {
									resData[key].forEach((item, index_) => {
										let lenIndex = lenData.findIndex((kk) => {
											return kk == item.acquisitionItemName
										})
										if (lenIndex > -1) {
										} else {
											let codeUnits = ''
											if (
												item.acquisitionItemUnitCode &&
												item.acquisitionItemUnitCode != ' ' &&
												item.acquisitionItemUnitCode != ''
											) {
												codeUnits =
													'(' +
													item.acquisitionItemUnitCode +
													')'
											} else {
												codeUnits = ''
											}
											this.$set(
												this.dataUnits,
												item['acquisitionItemName'],
												item['acquisitionItemUnitCode']
											)
											let aa = {
												show: true,
												name: codeUnits,
												type: 'value',
												nameTextStyle: {
													color: '#999',
													fontSize: 14,
													// align: 'center'
													padding: [0, 30, 0, 0],
												},
												position: 'left',
												axisLine: {
													show: true,
													lineStyle: {
														color: '#EDEDED',
														width: 2,
													},
												},
												minInterval: 1, //默认以1位分割单位，不允许出现小数点的情况
												axisLabel: {
													fontSize: 14,
													color: '#999',
												},
												splitLine: {
													show: true,
													lineStyle: {
														color: '#e9e9e9',
													},
												},
												offset: index_ * 50,
											}
											yAxis.push(aa)
											series.push({
												animationDelay: 200,
												animationDuration: 3000,
												name: item.acquisitionItemName,
												smooth: true,
												showSymbol: false,
												symbolSize: 14,
												type: 'line',
												data: [],
												unit: item.acquisitionItemUnitCode,
												yAxisIndex: index_,
											})
											lenData.push(item.acquisitionItemName)
										}
									})
								})
								// yAxis.forEach((item, index) => {
								//   item.offset = index * 50;
								// });
								// series.forEach((item, index) => {
								//   item.yAxisIndex = index;
								// });

								xData.sort(function (a, b) {
									return b < a ? 1 : -1
								})

								xData.forEach((xitem, xindex) => {
									lenData.forEach((litem, lindex) => {
										series[lindex]['data'][xindex] = 0
										resData[xitem].forEach((ditem, dindex) => {
											if (ditem.acquisitionItemName == litem) {
												series[lindex]['data'][xindex] =
													ditem.acquisitionData
											}
										})
									})
								})
							}
							// console.log(xData.length);
							// 绘制图表
							if (xData.length) {
								this.isShowLine = true
								this.$nextTick(() => {
									// this.makeChart(xData, yAxis, series, dataTypeNum);
									this.makeChart(xData, yAxis, series, dataTypeNum)
								})
							} else {
								this.isShowLine = false
							}
						} else {
							this.isShowLine = false
						}
					} else {
						this.isShowLine = false
					}
				})
				.catch(() => {
					this.isShowLine = false
				})
				.finally((err) => {
					setTimeout(() => {
						this.loading = false
					}, 500)
				})
		},
		// 请求折线图数据 ---- 多设备单参数
		getMoreLineData() {
			let params = this.queryArrParam

			// console.log(params);
			this.$http
				.postAction(this.url.moreLineChart, params)
				.then((res) => {
					if (res.meta.success) {
						let datas = res.data
						this.moreAllData = datas || {}
						if (datas && datas != {} && datas.series.length) {
							// console.log(123);
							this.isShowLine = true
							// datas = {
							// 	yAxis: {
							// 		formatter: '℃',
							// 		name: '土壤温度',
							// 	},
							// 	series: [
							// 		{
							// 			name: '设备一',
							// 			unit: '℃',
							// 			data: [
							// 				['2022-06-30 00:02:05', '18.60'],
							// 				['2022-06-30 00:07:04', '18.60'],
							// 				['2022-06-30 00:12:04', '18.60'],
							// 				['2022-06-30 00:17:03', '18.60'],
							// 			],
							// 		},
							// 		{
							// 			name: '设备二',
							// 			unit: '℃',
							// 			data: [
							// 				['2022-06-30 00:02:05', '15.90'],
							// 				['2022-06-30 00:07:04', '15.90'],
							// 				['2022-06-30 00:12:04', '15.80'],
							// 				['2022-06-30 00:17:03', '15.90'],
							// 			],
							// 		},
							// 		{
							// 			name: '设备三',
							// 			unit: '℃',
							// 			data: [
							// 				['2022-06-30 00:02:05', '20.60'],
							// 				['2022-06-30 00:07:04', '18.60'],
							// 				['2022-06-30 00:12:04', '50.60'],
							// 			],
							// 		},
							// 	],
							// 	orgs: ['设备一', '设备二'],
							// }
							// console.log(datas);
							let xData = []
							let yAxis = {}
							let series = []
							let isData = false
							Object.keys(datas).forEach((item, index) => {
								// console.log(item);
								if (item == 'yAxis') {
									yAxis = datas[item]
									yAxis.yname = datas[item].name
									yAxis.name = yAxis.unit

									yAxis.formatter = yAxis.unit
									yAxis.type = 'value'
									yAxis.position = 'left'
									yAxis.nameTextStyle = {
										color: '#6B6B6B',
										fontSize: 14,
										align: 'right',
									}
									yAxis.axisLabel = {
										color: '#6B6B6B',
										fontSize: 14,
									}
									yAxis.axisLine = {
										show: true,
										lineStyle: {
											color: '#EDEDED',
											width: 2,
										},
									}
									yAxis.splitLine = {
										show: true,
										lineStyle: {
											color: 'rgba(9, 116, 124, .3)',
										},
									}
									yAxis.offset = 0
								}
								if (item == 'series') {
									datas[item].forEach((item2, index2) => {
										if (item2.data && item2.data.length) {
											isData = true
											item2.data.sort(function (a, b) {
												let obj1 = a[0]
												let obj2 = b[0]
												const val1 = Math.floor(
													new Date(obj1).getTime() / 1000
												)
												const val2 = Math.floor(
													new Date(obj2).getTime() / 1000
												)
												return val2 - val1
											})
											let thisSerise = item2
											thisSerise.smooth = true
											thisSerise.showSymbol = false
											thisSerise.symbolSize = 10
											;(thisSerise.itemStyle = {
												borderWidth: 8,
											}),
												(thisSerise.type = 'line')

											series.push(thisSerise)
										}

										// 	let time = []
										// 	let value = []
										// 	item2.data.forEach((item3, index3) => {
										// 		time.push(item3[0])
										// 		value.push(item3[1])
										// 	})
										// 	xData.push({
										// 		// name: "设备一",
										// 		type: 'category',
										// 		position: 'bottom',
										// 		offset: 0,
										// 		// 刻度线
										// 		axisTick: {
										// 			show: false,
										// 		},
										// 		axisLine: {
										// 			lineStyle: {
										// 				color: '#EDEDED',
										// 				width: 2,
										// 			},
										// 		},
										// 		axisLabel: {
										// 			color: '#6B6B6B',
										// 			fontSize: 14,
										// 		},
										// 		boundaryGap: false,
										// 		data: time,
										// 	})
										// 	if (index2 != 0) {
										// 		xData[index2].show = false
										// 	}
										// 	series.push({
										// 		name: item2.name,
										// 		type: 'line',
										// 		smooth: true,
										// 		unit: item.unit,
										// 		// xAxisIndex: index2,
										// 		data: value,
										// 	})
									})
								}
							})
							// 绘制图表
							if (isData) {
								this.isShowLine = true
								this.$nextTick(() => {
									this.makeChartMore(xData, yAxis, series)
								})
							} else {
								this.isShowLine = false
							}
						} else {
							this.isShowLine = false
						}
					} else {
						this.isShowLine = false
					}
				})
				.catch(() => {
					this.isShowLine = false
				})
				.finally((err) => {
					setTimeout(() => {
						this.loading = false
					}, 500)
				})
		},
		// 折线图绘制
		makeChart(xData, yAxis, series, dataTypeNum) {
			// console.log(xData);
			// console.log(yAxis);
			// console.log(series);
			// let xType = yAxis.length == 1 ? "category" : "time";
			var num = '3%'
			if (yAxis.length == 1) {
				num = '4%'
			}
			if (yAxis.length == 2) {
				num = '3%'
			}
			if (yAxis.length == 3) {
				num = '5%'
			}
			if (yAxis.length > 3) {
				num = '3%'
			}
			const _this = this
			let myChart = this.$echarts.init(this.$refs.chartRef)
			let radioIndex_ = this.radioIndex
			let option = {
				tooltip: {
					show: true,
					trigger: 'axis',
					backgroundColor: '#fff',
					padding: [11, 17],
					extraCssText:
						'box-shadow: 0px 0px 12px 0px rgba(76, 216, 179, 0.33);text-align:left;font-size:14px;color:#3F3F3F;letter-spacing: 1px;',
					formatter: function (param) {
						// console.log(param);
						let infos = ''
						infos += `<div style="text-align:left;"></div><div style="margin:12px 0">${param[0].name}</div>`
						// 传感器并且选中前两个
						if ((radioIndex_ == 1 || radioIndex_ == 2) && dataTypeNum == 1) {
							param.forEach((item, index) => {
								infos += `<div  style="padding: 5px 0;color:${
									item.color
								}">${item.seriesName}: ${item.value[1]}${
									radioIndex_ == 1 ? '℃' : '%'
								}</div>`
							})
						} else {
							param.forEach((item, index) => {
								infos += `<div  style="padding: 5px 0;color:${
									item.color
								}">${item.seriesName}: ${item.value}${
									_this.dataUnits[item.seriesName]
								}</div>`
							})
						}

						return infos
					},
				},
				color: ['#2DAEA9', '#44A8FF', '#ff8cfb'],
				legend: {
					show: true,
					icon: 'rect',
					top: '3%',
					right: 'center',
					align: 'left',
					itemWidth: 22,
					itemHeight: 11,
					itemGap: 30,
					selectedMode: false,
					textStyle: {
						color: '#6B6B6B',
						fontSize: 12,
					},
				},
				grid: {
					left: num,
					bottom: '8%',
					top: '15%',
					right: '5%',
					containLabel: true,
				},
				xAxis: {
					type: 'category',
					data: xData,
					// 刻度线
					axisTick: {
						show: false,
					},
					axisLine: {
						lineStyle: {
							color: '#EDEDED',
							width: 2,
						},
					},
					axisLabel: {
						color: '#6B6B6B',
						fontSize: 14,
						margin: 15,
						lineHeight: 15,
						width: 80,
						overflow: 'breakAll',
					},
					boundaryGap: false,
				},
				// xAxis: {
				//   type: xType,
				//   //   maxInterval: 3600 * 24 * 1000,
				//   minInterval: 3600 * 24,
				//   axisLabel: {
				//     color: "#6B6B6B",
				//     fontSize: 14,
				//     margin: 15,
				//     lineHeight: 15,
				//     width: 80,
				//     overflow: "breakAll",
				//     formatter: function (value) {
				//       var date = _this.formateDate(
				//         new Date(value),
				//         "yyyy-MM-dd hh:mm:ss"
				//       );
				//       return date;
				//     },
				//   },
				//   //   position: "bottom",
				//   //   offset: 0,
				//   axisTick: {
				//     show: false,
				//   },
				//   axisLine: {
				//     lineStyle: {
				//       color: "#EDEDED",
				//       width: 2,
				//     },
				//   },
				//   boundaryGap: false,
				// },
				yAxis: yAxis,
				series: series,
			}
			myChart.clear()
			myChart.setOption(option)
			window.addEventListener('resize', function () {
				myChart.resize()
			})
		},
		// 多设备折线图绘制
		makeChartMore(xData, yAxis, series) {
			console.log(yAxis, series)
			let xType = yAxis.length == 1 ? 'category' : 'time'
			var num = '3%'
			if (yAxis.length == 1) {
				num = '4%'
			}
			if (yAxis.length == 2) {
				num = '3%'
			}
			if (yAxis.length == 3) {
				num = '5%'
			}
			if (yAxis.length > 3) {
				num = '3%'
			}
			const _this = this
			let myChart = this.$echarts.init(this.$refs.chartRef)
			let option = {
				tooltip: {
					show: true,
					trigger: 'axis',
					backgroundColor: '#fff',
					padding: [11, 17],
					extraCssText:
						'box-shadow: 0px 0px 12px 0px rgba(76, 216, 179, 0.33);text-align:left;font-size:14px;color:#3F3F3F;letter-spacing: 1px;',
					// formatter: function (param) {
					// 	console.log(param)
					// 	let infos = ''
					// 	infos += `<div style="text-align:left;"></div><div style="margin:12px 0">${yAxis.yname}<div style="margin:12px 0">${param[0].name}</div></div>`
					// 	param.forEach((item, index) => {
					// 		infos += `<div  style="padding: 5px 0;color:${item.color}">${item.seriesName}: ${item.value}${yAxis.unit}</div>`
					// 	})
					// 	// infos += `<div style="text-align:left;">${param.seriesName}</div><div style="margin:12px 0">${param.name}</div>`
					// 	// infos += `<div  style="padding: 5px 0;color:${param.color}">${yAxis.yname}: ${param.value}${yAxis.unit}</div>`
					// 	return infos
					// },
					formatter: function (value) {
						var vdata1 = value[0].data
						var date = vdata1[0]
						//去除重复数据
						for (var i = 0; i < value.length; i++) {
							for (var j = value.length - 1; j > i; j--) {
								if (value[j].seriesName == value[i].seriesName) {
									value.splice(j, 1)
									break
								}
							}
						}
						var html = date + '</br>'
						for (var i = 0; i < value.length; i++) {
							var color = value[i].color
							html =
								html +
								'<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:' +
								color +
								'"></span>'
							var seriesName = value[i].seriesName
							var vdata = value[i].data
							var ser = seriesName + '：' + vdata[1]
							html = html + ser + yAxis.name
							if (i != value.length - 1) {
								html = html + '</br>'
							}
						}
						return html
					},
				},
				color: ['#2DAEA9', '#44A8FF', '#ff8cfb'],
				legend: {
					show: true,
					icon: 'rect',
					top: '3%',
					right: 'center',
					align: 'left',
					itemWidth: 22,
					itemHeight: 11,
					itemGap: 30,
					textStyle: {
						color: '#6B6B6B',
						fontSize: 12,
					},
				},
				grid: {
					left: num,
					bottom: '8%',
					top: '15%',
					right: '5%',
					containLabel: true,
				},
				xAxis: {
					type: xType,
					//   maxInterval: 3600 * 24 * 1000,
					minInterval: 3600 * 24,
					axisLabel: {
						color: '#6B6B6B',
						fontSize: 14,
						margin: 15,
						lineHeight: 15,
						width: 80,
						overflow: 'breakAll',
						formatter: function (value) {
							var date = _this.formateDate(
								new Date(value),
								'yyyy-MM-dd hh:mm:ss'
							)
							return date
						},
					},
					//   position: "bottom",
					//   offset: 0,
					axisTick: {
						show: false,
					},
					axisLine: {
						lineStyle: {
							color: '#EDEDED',
							width: 2,
						},
					},
					boundaryGap: false,
				},
				yAxis: yAxis,
				series: series,
			}
			myChart.clear()
			myChart.setOption(option)
			window.addEventListener('resize', function () {
				myChart.resize()
			})
		},
		// arr是原数组，N是想分成多少个
		fenge(arr, N) {
			var result = []
			for (var i = 0; i < arr.length; i += N) {
				result.push(arr.slice(i, i + N))
			}
			return result
		},
		// 导出
		exportDownLoad() {
			const _this = this
			console.log('导出')
			// 单设备多参数导出
			if (this.isOneOption) {
				let params = JSON.parse(JSON.stringify(this.queryParam))
				params.startTime = `${params.startTime} 00:00:00`
				params.endTime = `${params.endTime} 23:59:59`
				this.orgSelect.forEach((item) => {
					if (item.facId == params.deviceCode) {
						this.$set(params, 'type', item.type)
					}
				})
				if (params.type != 1) {
					this.$set(params, 'orgId', '')
				} else {
					let orgId_ = ''
					let deviceCode_ = []
					this.orgSelect.forEach((item) => {
						if (item.facId == params.deviceCode) {
							orgId_ = item.orgId
							deviceCode_.push(item.serialNumber)
							this.$set(params, 'orgId', orgId_)
							this.$set(params, 'deviceCode', deviceCode_)
						}
					})
				}
				if (params.deviceCode.length) {
					this.$set(params, 'deviceCode', params.deviceCode[0])
				} else {
					this.$set(params, 'deviceCode', this.orgSelect[0]['facId'])
					this.$set(this.queryParam.deviceCode, 0, this.orgSelect[0].facId)
				}
				this.$http.postAction(this.url.oneLineChart, params).then((res) => {
					let dataTypeNum = Object.keys(res.data)
					if (dataTypeNum == 1) {
						let result = res.data[dataTypeNum]
						let timeArr
						let tableData = []
						let fileHead = ['序号', '创建时间']
						let filterVal = ['index', 'time']
						Object.keys(result).forEach((item, index) => {
							if (index == 0) {
								// 时间数据
								timeArr = result[item].acquisitionTimes
								timeArr.reverse()
							}
							result[item].values.reverse()
							timeArr.forEach((item2, index2) => {
								tableData.push({
									index: index2 + 1,
									time: item2,
								})
								// result[item].values.reverse()
								tableData[index2][result[item].acquisitionItem] =
									result[item].values[index2]
							})
							if (
								result[item].acquisitionItemName == 'PH' ||
								result[item].acquisitionItemName == 'ph'
							) {
								fileHead.push(`${result[item].acquisitionItemName}`)
							} else {
								fileHead.push(
									`${result[item].acquisitionItemName}(${result[item].unit})`
								)
							}

							filterVal.push(result[item].acquisitionItem)
						})
						console.log(tableData)
						// tableData.reverse()
						let tableData_ = tableData.splice(0, timeArr.length)
						this.$nextTick(() => {
							this.handleExportXls(
								tableData_,
								fileHead,
								filterVal,
								'环境参数分析'
							)
						})
					}
					if (dataTypeNum == 2) {
						let result = res.data[dataTypeNum]
						let timeArr = []
						let tableData = []
						let fileHead = ['序号', '创建时间']
						let filterVal = ['index', 'time']
						Object.keys(result).forEach((item, index) => {
							timeArr.push(item)
						})
						timeArr.reverse()
						timeArr.forEach((item, index) => {
							tableData.push({
								index: index + 1,
								time: item,
							})
							result[item].forEach((item2, index2) => {
								if (index == 0) {
									if (
										item2.acquisitionItemName == 'PH' ||
										item2.acquisitionItemName == 'ph'
									) {
										fileHead.push(item2.acquisitionItemName)
									} else {
										fileHead.push(
											item2.acquisitionItemName +
												'(' +
												item2.acquisitionItemUnitCode +
												')'
										)
									}
									filterVal.push(item2.acquisitionItem)
								}
								tableData[index][item2.acquisitionItem] =
									item2.acquisitionData
							})
						})
						console.log(tableData)
						this.$nextTick(() => {
							this.handleExportXls(
								tableData,
								fileHead,
								filterVal,
								'环境参数分析'
							)
						})
					}
					if (dataTypeNum == 3) {
						let result = res.data[dataTypeNum]
						let timeArr = []
						let tableData = []
						let fileHead = ['序号', '创建时间']
						let filterVal = ['index', 'time']
						Object.keys(result).forEach((item, index) => {
							timeArr.push(item)
						})
						timeArr.reverse()
						timeArr.forEach((item, index) => {
							tableData.push({
								index: index + 1,
								time: item,
							})
							result[item].forEach((item2, index2) => {
								if (index == 0) {
									if (
										item2.acquisitionItemName == 'PH' ||
										item2.acquisitionItemName == 'ph'
									) {
										fileHead.push(item2.acquisitionItemName)
									} else {
										fileHead.push(
											item2.acquisitionItemName +
												'(' +
												item2.acquisitionItemUnitCode +
												')'
										)
									}

									filterVal.push(item2.acquisitionItem)
								}
								tableData[index][item2.acquisitionItem] =
									item2.acquisitionData
							})
						})
						console.log(tableData)
						this.$nextTick(() => {
							this.handleExportXls(
								tableData,
								fileHead,
								filterVal,
								'环境参数分析'
							)
						})
					}
				})
			} else {
				// // 多设备单参数导出
				// let params = {
				// 	dict: JYLDAY,
				// 	start: '2022 - 06 - 29',
				// 	end: '2022 - 06 - 30',
				// 	orgs: ['1539765856953806849'],
				// 	facIds: ['16081971'],
				// }
				// this.$http.postAction('https://ibms.hnyfkj.com/sys/zhReport/exportSingleExcel', params).then((res) => {
				// 	console.log(res)
				// })

				// const _this = this
				// let faceids = []
				// let orgids = []
				// this.queryArrParam.forEach((item) => {
				// 	faceids.push(item.deviceCode)
				// 	orgids.push(item.orgId)
				// })
				// let params = {
				// 	dict: this.moreSbItemAct,
				// 	start: this.queryParam.startTime,
				// 	end: this.queryParam.endTime,
				// 	orgs: JSON.stringify(orgids),
				// 	facIds: JSON.stringify(faceids),
				// }
				// this.$http.postAction('sys/zhReport/exportSingleExcel', qs.stringify(params)).then((res) => {
				// 	window.layui.use('excel', function () {
				// 		var excel = layui.excel
				// 		var colConf = excel.makeColConfig(
				// 			{
				// 				//设置每列的宽度
				// 				A: 120,
				// 				Z: 120,
				// 			},
				// 			120
				// 		)
				// 		var rowConf = excel.makeRowConfig(
				// 			{
				// 				1: 30,
				// 			},
				// 			20
				// 		)
				// 		var fileName = '雨量累计分析.xlsx'

				// 		if (res.meta.success == true) {
				// 			var dataRes = res.data
				// 			var orgList = dataRes.orgList
				// 			var title = dataRes.title
				// 			var dataList = dataRes.dataMap
				// 			var titleList = dataRes.titleList
				// 			var areaCount = dataRes.areaCount
				// 			var paramCount = dataRes.paramCount
				// 			var array = _this.getArray(areaCount, paramCount)
				// 			var mergeConf = excel.makeMergeConfig(array)
				// 			dataList.unshift(title)
				// 			dataList.unshift(orgList)
				// 			var data = excel.filterExportData(dataList, titleList)
				// 			excel.setExportCellStyle(data, 'A1:AB1', {
				// 				s: {
				// 					font: { bold: true, sz: 14 },
				// 					alignment: {
				// 						horizontal: 'center',
				// 						vertical: 'center',
				// 					},
				// 				},
				// 			})
				// 			excel.exportExcel(
				// 				{
				// 					sheet1: data,
				// 				},
				// 				fileName,
				// 				'xlsx',
				// 				{
				// 					extend: {
				// 						'!cols': colConf,
				// 						'!merges': mergeConf,
				// 						'!rows': rowConf,
				// 					},
				// 				}
				// 			)
				// 			// parent.layer.close(index);
				// 		} else {
				// 			//       setTimeout(function () { parent.layer.close(index) }, 2000);//延迟
				// 			// layer.msg("暂无数据导出！");
				// 			return
				// 		}
				// 	})
				// })

				if (this.moreAllData && JSON.stringify(this.moreAllData) != '{}') {
					let series = this.moreAllData.series
					let timesAll = []
					let dataAll = []
					//   let actName = _this.moreSbItemList[actNameIndex]["itemName"]; //采集项名字
					let actName = this.moreAllData.yAxis.yname
					let txt = ''
					if (actName && actName != '' && actName != ' ' && actName != 'ph') {
						txt = '采集项（' + this.moreAllData.yAxis.name + ')'
					} else {
						txt = '采集项'
					}
					let fileHead = ['时间', txt]
					let filterVal = ['times', 'caijiName']
					series.forEach((item, index) => {
						let oneTime = []
						let oneData = []
						let equipCodeIndex = this.orgSelect.findIndex((a) => {
							return (
								a.facName == item.name ||
								a.facName.indexOf(item.name) > -1
							)
						})
						let equipCode = this.orgSelect[equipCodeIndex]['facId']
						if (item.data.length) {
							fileHead.push(item.name)
							filterVal.push(`${item.name}val`)
							item.data.forEach((item1) => {
								oneTime.push(item1[0])
								oneData.push({
									times: item1[0],
									values: item1[1],
									unit: item.unit,
									name: item.name,
									code: equipCode,
									types: `${item.name}val`,
								})
							})
						}

						dataAll = dataAll.concat(oneData)
						timesAll = timesAll.concat(oneTime)
					})

					// 所有的时间
					timesAll = [...new Set(timesAll)]
					// console.log(timesAll)
					// console.log(dataAll)
					let listArr = []
					dataAll.forEach((item, index) => {
						timesAll.forEach((item1) => {
							if (item1 == item.times) {
								let isHadIndex = listArr.findIndex((item2) => {
									return item2.times == item1
								})
								// console.log(isHadIndex)
								if (isHadIndex > -1) {
									listArr[isHadIndex][item.code] = item.name
									listArr[isHadIndex][item.types] = item.values
									listArr[isHadIndex]['caijiName'] = actName
								} else {
									listArr.push({
										times: item.times,
										[item.code]: item.name,
										[item.types]: item.values,
										caijiName: actName,
									})
								}
							}
						})
					})
					listArr.sort(function (a, b) {
						let obj1 = a['times']
						let obj2 = b['times']
						const val1 = Math.floor(new Date(obj1).getTime() / 1000)
						const val2 = Math.floor(new Date(obj2).getTime() / 1000)
						return val2 - val1
					})
					let actNameIndex = _this.moreSbItemList.findIndex((item) => {
						return item.itemCode == _this.moreSbItemAct
					})

					let fileList = listArr
					console.log(fileList)
					this.$nextTick(() => {
						this.handleExportXls(
							fileList,
							fileHead,
							filterVal,
							//   actName + "参数分析"
							'环境参数分析'
						)
					})
				}
			}
		},
		getArray(aCount, pCount) {
			if (aCount == 1) {
				if (pCount == 2) return [['A1', 'B1']]
				if (pCount == 3) return [['A1', 'C1']]
				if (pCount == 4) return [['A1', 'D1']]
				if (pCount == 5) return [['A1', 'E1']]
				if (pCount == 6) return [['A1', 'F1']]
				if (pCount == 7) return [['A1', 'G1']]
			}
			if (aCount == 2) {
				if (pCount == 2)
					return [
						['A1', 'B1'],
						['C1', 'D1'],
					]
				if (pCount == 3)
					return [
						['A1', 'C1'],
						['D1', 'F1'],
					]
				if (pCount == 4)
					return [
						['A1', 'D1'],
						['E1', 'H1'],
					]
				if (pCount == 5)
					return [
						['A1', 'E1'],
						['F1', 'J1'],
					]
				if (pCount == 6)
					return [
						['A1', 'F1'],
						['G1', 'L1'],
					]
				if (pCount == 7)
					return [
						['A1', 'G1'],
						['H1', 'N1'],
					]
			}
			if (aCount == 3) {
				if (pCount == 2)
					return [
						['A1', 'B1'],
						['C1', 'D1'],
						['E1', 'F1'],
					]
				if (pCount == 3)
					return [
						['A1', 'C1'],
						['D1', 'F1'],
						['G1', 'I1'],
					]
				if (pCount == 4)
					return [
						['A1', 'D1'],
						['E1', 'H1'],
						['I1', 'L1'],
					]
				if (pCount == 5)
					return [
						['A1', 'E1'],
						['F1', 'J1'],
						['L1', 'P1'],
					]
				if (pCount == 6)
					return [
						['A1', 'F1'],
						['G1', 'L1'],
						['M1', 'R1'],
					]
				if (pCount == 7)
					return [
						['A1', 'G1'],
						['H1', 'N1'],
						['O1', 'U1'],
					]
			}
			if (aCount >= 4) {
				if (pCount == 2)
					return [
						['A1', 'B1'],
						['C1', 'D1'],
						['E1', 'F1'],
						['G1', 'H1'],
					]
				if (pCount == 3)
					return [
						['A1', 'C1'],
						['D1', 'F1'],
						['G1', 'I1'],
						['J1', 'L1'],
					]
				if (pCount == 4)
					return [
						['A1', 'D1'],
						['E1', 'H1'],
						['I1', 'L1'],
						['M1', 'P1'],
					]
				if (pCount == 5)
					return [
						['A1', 'E1'],
						['F1', 'J1'],
						['L1', 'P1'],
						['Q1', 'U1'],
					]
				if (pCount == 6)
					return [
						['A1', 'F1'],
						['G1', 'L1'],
						['M1', 'R1'],
						['S1', 'X1'],
					]
				if (pCount == 7)
					return [
						['A1', 'G1'],
						['H1', 'N1'],
						['O1', 'U1'],
						['V1', 'AB1'],
					]
			}
		},
	},
}
</script>

<style lang="scss" scoped>
.environapage {
	height: 100%;
}
// 下面的折线图
.chart-all {
	margin-top: 0.15rem;
	width: 20.07rem;
	// height: 9.19rem;
	flex: 1;
	min-height: 610px;
	background: #ffffff;
	border-radius: 0.19rem;
	position: relative;
	// 导出按钮
	.btn-export {
		width: 1.05rem;
		height: 0.45rem;
		color: #42b5b2;
		border: 1px solid #2daea9;
		border-radius: 4px;
		font-size: 0.17rem;
		position: absolute;
		top: 0.31rem;
		right: 0.39rem;
		cursor: pointer;
		z-index: 20;
		img {
			width: 0.25rem;
			margin-right: 0.09rem;
		}
	}
	.chart-div {
		width: 20.07rem;
		height: 100%;
	}
	.bottom-empty {
		height: 8.5rem;
		height: 100%;
	}
	.chart-title {
		color: #333;
	}
}
</style>
<style lang="scss">
.environapage {
	.warnform-inline {
		.form-inputs {
			.el-form-item:not(:last-child) {
				margin-right: 1.2vw;
			}
			.form-radio-group {
				margin-right: 1.2vw;
			}
			.el-select {
				width: 2.3rem;
				transition: width 0.1s;
			}
			.selest-more {
				width: 2.8rem;
			}
			.el-select__tags {
				flex-wrap: nowrap;
			}
		}
	}
	@media screen and (max-width: 1535px) {
		.warnform-inline {
			padding: 0 0.1rem;
			.form-inputs {
				.el-form-item {
					&:not(:last-child) {
						margin-right: 1.1vw;
					}
				}
				.el-select {
					width: 2.2rem;
				}
				.selest-more {
					width: 2.9rem;
				}
				.el-radio {
					margin-right: 1vw;
				}
			}
		}
	}
	@media screen and (max-width: 1380px) {
		.warnform-inline {
			padding: 0 0.1rem;
			.form-inputs {
				.el-form-item {
					&:not(:last-child) {
						margin-right: 0.5vw;
					}
				}
				.el-select {
					width: 2rem;
				}
				.selest-more {
					width: 3rem;
				}
			}
		}
	}
	@media screen and (max-width: 1310px) {
		.warnform-inline {
			padding: 0 0.1rem;
			.form-inputs {
				.el-form-item {
					&:not(:last-child) {
						margin-right: 0.5vw;
					}
				}
				.el-select {
					width: 1.8rem;
				}
				.selest-more {
					width: 3rem;
				}
				.form-radio-group {
					margin-right: 1vw;
				}
			}
		}
	}
}
.el-tag.el-tag--info {
	max-width: 1.5rem !important;
}
</style>
